import React, { Component } from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { getProductsDBRef } from "../../helpers";
import { getProductStorageRef } from "../../helpers";
import { Markup } from "interweave";

const responsive = {
  desktop: {
    breakpoint: {
      max: 3000,
      min: 1024,
    },
    items: 4,
    partialVisibilityGutter: 50,
  },
  mobile: {
    breakpoint: {
      max: 464,
      min: 0,
    },
    items: 1,
    partialVisibilityGutter: 30,
  },
  tablet: {
    breakpoint: {
      max: 1024,
      min: 464,
    },
    items: 3,
    partialVisibilityGutter: 30,
  },
};

class MultiCarousel extends Component {
  state = {
    carouselItems: [],
    isLoading: false,
  };

  componentDidMount() {
    const siteId = window.Config.siteId;
    this.setState({ isLoading: true });

    getProductsDBRef(siteId).on("value", (snapshot) => {
      const products = snapshot.val();
      // console.log(products);
      let promises = [];

      products.forEach((product) => {
        promises.push(
          getProductStorageRef(siteId).child(product.image).getDownloadURL()
        );
      });

      Promise.all(promises).then((urls) => {
        let temp = [];
        products.forEach((product, index) => {
          product.url = "";
          urls.forEach((u) => {
            if (u.indexOf(product.image) > 0) {
              product.url = u;
            }
          });
          temp.push(
            <div className="card" key={index}>
              <div className="card-img">
                <img
                  src={product.url}
                  className="card-img-top"
                  alt={product.title}
                />
              </div>
              <div className="card-body">
                <h3 className="card-title">{product.title}</h3>
                <div className="card-text">
                  <Markup content={product.desc} />
                </div>
              </div>
            </div>
          );
        });
        this.setState({ carouselItems: temp, isLoading: false });
      });
    });
  }

  render() {
    return (
      <div
        style={{
          position: "relative",
        }}
      >
        <Carousel
          class="multicarousel"
          additionalTransfrom={0}
          arrows
          autoPlaySpeed={3000}
          centerMode={true}
          className=""
          infinite
          containerClass="container"
          dotListClass=""
          draggable
          focusOnSelect={false}
          itemClass=""
          keyBoardControl
          minimumTouchDrag={80}
          renderButtonGroupOutside={false}
          renderDotsOutside
          responsive={responsive}
          showDots
          sliderClass=""
          slidesToSlide={1}
          swipeable
        >
          {this.state.carouselItems}
        </Carousel>
      </div>
    );
  }
}

export default MultiCarousel;
